import { isDevelopmentMode } from "../env.js";
function throwDevError(msg) {
    if (isDevelopmentMode()) throw new Error(msg);
}
export { throwDevError };

//# sourceMappingURL=devLogger.js.map